import { ballArr, count, singleDouble, singleDoubleCnname, smallBig, continuity, continuityCnname, smallBigCnname, dragonTiger, fishCnname } from '../../../../helpers/resPatterns';
import dayjs from 'dayjs';
var dsChildren = data => {
  var arr = [];
  var shape = ['双', '单'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.className = `join_table_children`;
      obj.className = `table_dx_${i}`;
      obj.render = (h, { row }) => {
        var index = row.nowNum % 2;
        if (shape[i] == shape[index]) {
          return <span>{shape[i]}</span>;
        } else {
          return <span />;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
var dxChildren = data => {
  var arr = [];
  var shape = ['大', '小'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      obj.className = `table_dx_${i}`;
      obj.render = (h, { row }) => {
        var index = row.nowNum;
        if (shape[i] == '大' && row.nowNum > 5) {
          return <span>{shape[i]}</span>;
        } else if (shape[i] == '小' && row.nowNum < 6) {
          return <span>{shape[i]}</span>;
        } else {
          return <span />;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};

const ssc = (data, ballindex) => {
  let list = Vue => {
    let arr = [
      {
        title: '期号',
        align: 'center',
        className: `table_issueId`,
        width: 200,
        key: 'issue_id'
      },
      {
        // title: '单',
        renderHeader: (h, params) => {
          return h('div', [
            h('span', '同位开奖号码分布:  '),
            h(
              'Checkbox',
              {
                // props: {
                //   model: 'showBallNum'
                // },
                // v-model="single"
                on: {
                  'on-change': () => {
                    Vue.showBallNum = !Vue.showBallNum;
                    Vue.getDate();
                    // if (this.type == '0') {
                    //   this.$router.push('/UserNotice/' + params.row.id);
                    // } else {
                    //   this.$router.push('/TeamNotcie/' + params.row.id);
                    // }
                  }
                }
              },
              '显示同位号码'
            )
          ]);
        },
        align: 'center',
        width: 400,
        className: `table_issueId`,
        render: (h, { row }) => {
          return (
            <div class="pk10 pk_balls">
              {row.ballList.map((x, i) => {
                if (row.nowNum == x) {
                  return <span class={`c${x} red`} key={i} />;
                } else if (Vue.ballNum == x) {
                  return (
                    <span class={Vue.showBallNum ? `ball` : ''} key={i}>
                      {x}
                    </span>
                  );
                } else {
                  return <span key={i}>{x}</span>;
                }
              })}
            </div>
          );
        }
      },
      {
        title: '升平降',
        align: 'center',
        className: `table_issueId`,
        render: (h, row) => {
          // return <span>2</span>;
          var i = row.index;
          if (Number(data[i].nowNum) > Number(data[i + 1].nowNum)) {
            return <span class="ball_s">升</span>;
          } else if (Number(data[i].nowNum) == Number(data[i + 1].nowNum)) {
            return <span>平</span>;
          } else {
            return <span class="ball_j">降</span>;
          }
        }
      },
      {
        title: '单双',
        align: 'center',
        className: `table_issueId`,
        children: dsChildren(data)
      },
      {
        title: '大小',
        align: 'center',
        className: `table_issueId`,
        children: dxChildren(data)
      }
    ];

    return arr;
  };

  return { list };
};

export default ssc;



// WEBPACK FOOTER //
// ./src/pages/Trend/Haomaguilvtongji/columns/pk10.js